import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f970dc0&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f970dc0')) {
      api.createRecord('0f970dc0', component.options)
    } else {
      api.reload('0f970dc0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0f970dc0&", function () {
      api.rerender('0f970dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/venueBooking/index.vue"
export default component.exports